import PropTypes from 'prop-types';
import React from 'react';
import Validator from 'mixins/validator';
import Resetter from 'mixins/resetter';
import { Button } from 'react-toolbox';
import { connect } from 'react-redux';
import CheckBox from 'components/CheckBox';
import S from 'modal.scss';
import { getPhaseErrors } from '../../../../../../../../../../reducers';
import PhaseType from 'types/phase';

class InstallerPostWalkthrough extends Resetter(Validator(React.Component)) {
  state = {
    installerCarpetAllSeamsSealed: this.props.installerCarpetAllSeamsSealed || false,
    installerCarpetPowerStretched: this.props.installerCarpetPowerStretched || false,
    installerCarpetVacuumed: this.props.installerCarpetVacuumed || false,
    installerCarpetCleanedUp: this.props.installerCarpetCleanedUp || false,
    errors: {},
  };

  installerPostWalkthroughRef = React.createRef();

  componentDidMount = () => this.installerPostWalkthroughRef.current.scrollIntoView(false);

  handleSubmit = () => {
    const { installerCarpetAllSeamsSealed, installerCarpetPowerStretched,
      installerCarpetVacuumed, installerCarpetCleanedUp } = this.state;
    this.props.updateFormData({
      installerCarpetAllSeamsSealed,
      installerCarpetPowerStretched,
      installerCarpetVacuumed,
      installerCarpetCleanedUp,
      tab: 3,
    });
  }

  handlePrevious = () => {
    const { installerCarpetAllSeamsSealed, installerCarpetPowerStretched,
      installerCarpetVacuumed, installerCarpetCleanedUp } = this.state;
    this.props.updateFormData({
      installerCarpetAllSeamsSealed,
      installerCarpetPowerStretched,
      installerCarpetVacuumed,
      installerCarpetCleanedUp,
      tab: 1,
    });
  }

  handleInstallerCarpetAllSeamsSealed = () =>
    this.setState({ installerCarpetAllSeamsSealed: !this.state.installerCarpetAllSeamsSealed });

  handleInstallerCarpetPowerStretched = () =>
    this.setState({ installerCarpetPowerStretched: !this.state.installerCarpetPowerStretched });

  handleInstallerCarpetVacuumed = () =>
    this.setState({ installerCarpetVacuumed: !this.state.installerCarpetVacuumed });

  handleInstallerCarpetCleanedUp = () =>
    this.setState({ installerCarpetCleanedUp: !this.state.installerCarpetCleanedUp });

  render = () => {
    const { isSpanish } = this.props;
    const {
      installerCarpetAllSeamsSealed,
      installerCarpetPowerStretched,
      installerCarpetVacuumed,
      installerCarpetCleanedUp,
      errors,
    } = this.state;

    return (<div ref={this.installerPostWalkthroughRef}>
      <h6>
        {isSpanish ? 'Lista de Verificación del Instalador' : 'Installer Checklist'}
      </h6>
      <CheckBox
        required
        text={isSpanish
          ? 'Todas las costuras han sido selladas'
          : 'All seams have been sealed'
        }
        errors={errors.installerCarpetAllSeamsSealed}
        onChange={this.handleInstallerCarpetAllSeamsSealed}
        checked={installerCarpetAllSeamsSealed}
      />
      <CheckBox
        required
        text={isSpanish
          ? 'La alfombra ha sido estirada'
          : 'Carpet has been power stretched'
        }
        errors={errors.installerCarpetPowerStretched}
        onChange={this.handleInstallerCarpetPowerStretched}
        checked={installerCarpetPowerStretched}
      />
      <CheckBox
        required
        text={isSpanish
          ? 'La alfombra ha sido aspirada'
          : 'Carpet has been vacuumed'
        }
        errors={errors.installerCarpetVacuumed}
        onChange={this.handleInstallerCarpetVacuumed}
        checked={installerCarpetVacuumed}
      />
      <CheckBox
        required
        text={isSpanish
          ? 'He limpiado el patio, el garaje y / o el camino de entrada donde se cortó el material'
          : 'I have cleaned up the yard, garage, and/or driveway where the material was cut'
        }
        errors={errors.installerCarpetCleanedUp}
        onChange={this.handleInstallerCarpetCleanedUp}
        checked={installerCarpetCleanedUp}
      />
      <Button
        label={isSpanish ? 'Próximo' : 'Next'}
        flat inverse ripple
        className={S.submit}
        onClick={this.handleSubmit}
      />
      <Button
        label={isSpanish ? 'Anterior' : 'Previous'}
        flat inverse ripple
        className={S.submit}
        onClick={this.handlePrevious}
      />
    </div>);
  }
}

InstallerPostWalkthrough.propTypes = {
  isSpanish: PropTypes.bool,
  phase: PhaseType.isRequired,
  installerCarpetAllSeamsSealed: PropTypes.bool,
  installerCarpetPowerStretched: PropTypes.bool,
  installerCarpetVacuumed: PropTypes.bool,
  installerCarpetCleanedUp: PropTypes.bool,
  errors: PropTypes.shape({
    installerCarpetAllSeamsSealed: PropTypes.arrayOf(PropTypes.string),
    installerCarpetPowerStretched: PropTypes.arrayOf(PropTypes.string),
    installerCarpetVacuumed: PropTypes.arrayOf(PropTypes.string),
    installerCarpetCleanedUp: PropTypes.arrayOf(PropTypes.string),
  }),
};

export default connect(state => ({ errors: getPhaseErrors(state) }), {
})(InstallerPostWalkthrough);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/tasks/components/WalkthroughModal/post/installerPostWalkthrough.jsx